import { useEffect, useState } from "react";

// Per-device preference controlling the floating "Ask Sara" button.
const KEY = "besthr_ai_fab_enabled";
export const AI_FAB_EVENT = "besthr:ai-fab-changed";

export function getAiFabEnabled(): boolean {
  try {
    return localStorage.getItem(KEY) !== "false"; // default: enabled
  } catch {
    return true;
  }
}

export function setAiFabEnabled(enabled: boolean): void {
  try {
    localStorage.setItem(KEY, enabled ? "true" : "false");
  } catch {
    /* private mode / quota — ignore */
  }
  window.dispatchEvent(new CustomEvent(AI_FAB_EVENT, { detail: enabled }));
}

/** Reactive read of the "Ask Sara" FAB preference (updates when toggled anywhere). */
export function useAiFabEnabled(): boolean {
  const [enabled, setEnabled] = useState<boolean>(getAiFabEnabled);
  useEffect(() => {
    const onChange = () => setEnabled(getAiFabEnabled());
    window.addEventListener(AI_FAB_EVENT, onChange);
    window.addEventListener("storage", onChange);
    return () => {
      window.removeEventListener(AI_FAB_EVENT, onChange);
      window.removeEventListener("storage", onChange);
    };
  }, []);
  return enabled;
}
